import config from "../config";
import { bearerAuthorizationHeader } from "../../auth/util";

export const deleteDocument = (requestId, seqNo, primaryTerm, user) => {
    const { host } = config.apiGateway;
    const token = user?.access_token;
    const apiEndpoint = `${host}/document/delete?requestId=${requestId}&seqNo=${seqNo}&primaryTerm=${primaryTerm}`;
    return fetch(apiEndpoint, { method: "DELETE", ...bearerAuthorizationHeader(token) })
}